module.exports = __webpack_public_path__ + "static/media/product-5.bce8cb1b.png";